import styled from 'styled-components';

import Icon from 'components/Icon';

export const CheckboxWrapper = styled.div`
  margin: 1rem 0;
`;

export const SubmitWrapper = styled.div`
  margin-top: ${props => props.theme.spacing.xlarge};
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    width: fit-content;
  }
`;

export const InfoIcon = styled(Icon)`
  margin-left: ${props => props.theme.spacing.small};
  color: ${props => props.theme.color.wfBlue};
  position: relative;
  bottom: 5px;
`;
